"use strict";

exports.__esModule = true;
exports.default = void 0;
var _hashClear = _interopRequireDefault(require("./_hashClear.js"));
var _hashDelete = _interopRequireDefault(require("./_hashDelete.js"));
var _hashGet = _interopRequireDefault(require("./_hashGet.js"));
var _hashHas = _interopRequireDefault(require("./_hashHas.js"));
var _hashSet = _interopRequireDefault(require("./_hashSet.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear.default;
Hash.prototype['delete'] = _hashDelete.default;
Hash.prototype.get = _hashGet.default;
Hash.prototype.has = _hashHas.default;
Hash.prototype.set = _hashSet.default;
var _default = exports.default = Hash;